// store/modules/postCreator.js
export default {
    namespaced: true,
    state: {
        historySimulateResquest: {},

        dataStoryMakerDefault: {
            gifs: [],
            musics: {
                forYou: [],
                topTrends: [],
            },
            locations: [],
            shops: []
        },
        requestHisory: {
            mentions: {},
        },
        saveMetaDataUrl: {},
        youtubeCategories: [],
        pageStorage: {},
        dataEditPost:{},
        dataDuplicatePost: {},
        dataDraft:{}
    },
    mutations: {
        updateHistorySimulateRequest(state, newValue) {
            state.historySimulateResquest = {...state.historySimulateResquest, ...newValue};
        },
        updateRequestHisory(state, payload) {
            if (!state.requestHisory[payload.type])  state.requestHisory[payload.type] = {};
            if (!state.requestHisory[payload.type][payload.pageId]) state.requestHisory[payload.type][payload.pageId] = {};

            state.requestHisory[payload.type][payload.pageId][payload.search] = payload.data
        },
        updateDataStoryMakerDefault(state, payload) {
            state.dataStoryMakerDefault = {...state.dataStoryMakerDefault, ...payload};
        },
        addMetaDataUrl(state, newValue) {
            state.saveMetaDataUrl = {...state.saveMetaDataUrl, ...newValue};
        },
        setYoutubeCategories(state, newValue) {
            state.youtubeCategories = newValue;
        },
        setDataInPageStorage(state, payload) {
            const { pageId, dataName, data } = payload;

            state.pageStorage = {
                ...state.pageStorage,
                [pageId]: {
                    ...(state.pageStorage[pageId] || {}),
                    [dataName] : data
                }
            };
        },
        setDataForEditPost(state, newValue){
            state.dataEditPost = newValue
        },
        setDataForDuplicatePost(state, newValue){
            state.dataDuplicatePost = newValue
        },
        setDataForDraft(state, newValue){
            state.dataDraft = newValue
        }
    },
    getters: {
        historySimulateResquest(state) {
            return state.historySimulateResquest;
        },
        requestHisory(state) {
            return state.requestHisory;
        },
        dataStoryMakerDefault(state) {
            return state.dataStoryMakerDefault;
        },
        saveMetaDataUrl(state) {
            return state.saveMetaDataUrl;
        },
        youtubeCategories(state) {
            return state.youtubeCategories;
        },

        getPageData: (state) => (idPage) => {
            return state.pageStorage[idPage] || null;
        },
        getDataInPage: (state) => (idPage,dataName) => {
            return state.pageStorage[idPage] && state.pageStorage[idPage][dataName] ? state.pageStorage[idPage][dataName] : null;
        },
        getDataEditPost(state) {
            return state.dataEditPost;
        },
        getDataDuplicatePost(state) {
            return state.dataDuplicatePost;
        },
        getDataDraft(state) {
            return state.dataDraft;
        },


    },
};
